<ion-row>
  <ion-col size="12">
    <ion-card class="cancelledCard card-1">
      <div>
        <div class="card-header">
          <ion-label class="section-title" color="secondary">
            <fa-icon [icon]="faTimesCircle"></fa-icon>
            {{(toolService.content | async)?.application?.components?.cancel?.componentTitle}}
          </ion-label>
        </div>
      </div>
      <ion-card-content>
        <ion-list class="ion-text-center">
          <ion-item lines="none" class="ion-text-center">
            <ion-label class="ion-text-wrap">
              {{(toolService.content | async)?.application?.components?.cancel?.componentBody?.cancelText}}
            </ion-label>
          </ion-item>
          <ion-item lines="none">
            <fa-icon [icon]="faStar"></fa-icon>
            <ion-label class="ion-text-wrap">
              <ion-text>
                <p class="bold-text">Program Name: </p>
                <a [routerLink]="'/program/details/' + application?.program?.id"
                  class="link-anchor link-color">{{application?.name}}</a>
              </ion-text>
            </ion-label>
          </ion-item>
          <ion-item lines="none">
            <fa-icon [icon]="faMapMarkerAlt"></fa-icon>
            <ion-label class="ion-text-wrap">
              <ion-text>
                <p class="bold-text">Location: </p>
                <p>{{application?.programlocation}}</p>
              </ion-text>
            </ion-label>
          </ion-item>
          <ion-item lines="none">
            <fa-icon [icon]="faNotesMedical"></fa-icon>
            <ion-label class="ion-text-wrap">
              <ion-text>
                <p class="bold-text">Specialty: </p>
                <p>{{application?.specialty}}</p>
              </ion-text>
            </ion-label>
          </ion-item>
          <ion-button (click)="new()">
            {{(toolService.content | async)?.application?.components?.cancel?.componentBody?.searchButton}}
          </ion-button>
        </ion-list>
      </ion-card-content>
    </ion-card>
  </ion-col>
</ion-row>